import { Routes } from '@angular/router';

import { AcknowledgementType } from 'src/app/core/enums/acknowledgement-type.enum';
import { SUPPRESS_CHAT_BUTTON } from 'src/app/features/help-faq/components/chat-button-open/chat-button-suppression.service';
import { msalAuthGuard } from 'src/app/features/msal-auth/guards/msal-auth.guard';

import { legalAcknowledgementResolver } from '../../resolvers/legal-acknowledgement.resolver';
import { LegalAcknowledgementsStore } from '../../store/legal-acknowledgements.store';

export const termsRoutes: Routes = [
  AcknowledgementType.TermsOfUse,
  AcknowledgementType.PrivacyPolicy,
].map((type) => ({
  path: `terms/${type.toLowerCase()}`,
  canActivate: [msalAuthGuard],
  resolve: { legalAcknowledgement: legalAcknowledgementResolver },
  providers: [LegalAcknowledgementsStore],
  loadComponent: () =>
    import('./legal-acknowledgement-page.component').then(
      (m) => m.LegalAcknowledgementPageComponent,
    ),
  data: {
    acknowledgementType: type,
    pageName: `Legal - ${type}`,
    [SUPPRESS_CHAT_BUTTON]: true,
  },
}));
